import * as openpgp from "openpgp";
// import apiPublicKey from "../configs/pgpKeys/apiPublicKey";
import apiPublicKeyProd from "../configs/pgpKeys/apiPublicKeyProd";

const pgpEncrypt = async (text) => {
	const { data: encrypted } = await openpgp.encrypt({
		message: openpgp.message.fromText(text),
		publicKeys: (await openpgp.key.readArmored(apiPublicKeyProd)).keys,
	});

	return encrypted;
};

export { pgpEncrypt };
